import Hamburger from "./hmburger";

export default Hamburger;
